<template>
  <div>
    <a-form ref='form' :model='ruleForm' :style="{'marginBottom':'10px'}" :labelCol="{ span: 3 }"
      :wrapper-col="{ span: 11}" :initialValues="search" :onFinish='pageSearchChange'>
      <a-form-item label="是否开启定期清零" name=''>
        <a-radio-group v-model:value="dataMore.point_is_clear">
          <a-radio :value="0">
            不清理
          </a-radio>
          <a-radio :value="1">
            自然年清理前一年积分
          </a-radio>
        </a-radio-group>
        <SmallSquare class='m-b-45' content='1.每年12月31日24点，对用户手中前一年获得的积分进行清理；如：2022年12月31日24点，清理用户2021年获得的积分
2.首次开通功能，消费者累计积分统计到本年，下一年执行清理操作' v-if="dataMore.point_is_clear==1" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 4,offset:3}">
        <a-button type="primary" @click="onSubmit">
          保存设置
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
  import { QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { point_is_clear,getPoint } from "@/api/assets";
  import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
  export default {
    name: 'zeroSet',
    setup(props) {
      const state = reactive({
        dataMore:{
          point_is_clear: 0
        }
      });
      const onSubmit = async () => {
        let res = await point_is_clear(state.dataMore).then(res => res.data)
        if (iscode(res)) {
          message.success(res.msg);
        } else {
          message.error(res.msg);
        }
      }
      const initData = async () => {
        let res = await getPoint().then(res => res.data)
        if (iscode(res)) {
          if(!res.data.values)return
          state.dataMore =res.data.values;
        } else {
          message.error(res.msg);
        }
      }
      onMounted(() => {
        initData()
      });
      return {
        ...toRefs(state),
        onSubmit
      };
    },
  };
</script>